import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=19d7587b&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"
import style0 from "./EventList.vue?vue&type=style&index=0&id=19d7587b&prod&scoped=true&lang=css"
import style1 from "./EventList.vue?vue&type=style&index=1&id=19d7587b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d7587b",
  null
  
)

export default component.exports